import {
    AfterContentChecked,
    ChangeDetectorRef,
    Component,
    HostBinding,
    OnInit, signal,
    ViewChild
} from '@angular/core';
import { ApplicationSettings, NotificationHubService, NotificationService } from './core/services';
import { environment } from '../environments/environment';
import { WindowContainerComponent } from './window/window-container.component';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './core/store/app.model';
import { LayoutActionsService } from './core/store/layout/layout.actions.service';
import { MenuState, PreviewStatus } from './core/store/layout/layout.model';
import { PreviewContainerComponent } from './preview/preview-container/preview-container.component';
import { AppWithPreviewComponent } from './preview/preview.model';
import { AppWithWindowComponent } from './window/window.model';
import { ListDefinitionType } from './ladon-api-enums/WK.Ladon.Cms.Common.Model.Enum.ListDefinitionType';
import { ObiektListActionsService } from './core/store/obiekt-list/obiekt-list-actions.service';
import { selectObiektListListDefinitionType } from './core/store/obiekt-list/obiekt-list.selectors';
import { NotificationConnectionState } from './core/store/user/user.model';
import { selectUserForbiddenInfo, selectUserNotificationHubState } from './core/store/user/user.selectors';
import { AuthenticationService } from './authorization';
import { Title } from '@angular/platform-browser';
import { selectRequestsPendingRequests } from './core/store/requests/requests.selectors';
import { WindowComponent } from './window/window.component';

@Component({
    selector: 'ldn-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterContentChecked, AppWithPreviewComponent, AppWithWindowComponent {
    public loading = signal(false);
    public version: string;
    public production: boolean;
    public acceptance: boolean;

    public currentPreviewStatus: PreviewStatus;
    public currentPreviewVisibility: boolean;
    @HostBinding('class.float-menu')
    public floatMenu: boolean = true;
    private _menuState: MenuState;
    public set menuState(value: MenuState) {
        this._menuState = value;
        this.floatMenu = this._menuState === MenuState.Float;
    }

    @ViewChild(WindowContainerComponent)
    public windowContainer: WindowContainerComponent;

    @ViewChild(PreviewContainerComponent)
    public previewContainer: PreviewContainerComponent;

    public ListDefinitionType = ListDefinitionType; // aby można było wykorzystać enum w templejcie
    private listDefinitionType: ListDefinitionType;

    public notificationHubState: Observable<NotificationConnectionState>;
    public notificationHubVisible: boolean = false;

    constructor(private readonly appSettings: ApplicationSettings,
                private readonly store: Store<AppState>,
                private readonly layoutActionsService: LayoutActionsService,
                private readonly obiektListActionsService: ObiektListActionsService,
                private readonly notificationHubService: NotificationHubService,
                private readonly authenticationService: AuthenticationService,
                readonly titleService: Title,
                private readonly notificationService: NotificationService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.version = appSettings.settings.revision.substr(0, 15) + '…'; // max 15 znaków (np. 195.afg763522ab)

        this.production = environment.production;
        this.acceptance = environment.acceptance;

        if (this.production) {
            titleService.setTitle('Ladon');
        } else if (this.acceptance) {
            titleService.setTitle('Ladon - acc');
        }
        this.store.select(selectRequestsPendingRequests).subscribe(x => {
            setTimeout(() => {
                this.loading.set(x > 0);
            });
        });

        this.store.select(state => state.layout.previewVisible).subscribe(x => {
            this.currentPreviewVisibility = x;
        });
        this.store.select(state => state.layout.previewStatus).subscribe(x => {
            this.currentPreviewStatus = x;
        });
        this.store.select(state => state.layout.menuState).subscribe(x => {
            this.menuState = x;
        });
        this.store.select(selectObiektListListDefinitionType).subscribe(listDefinitionType => this.listDefinitionType = listDefinitionType);
        this.notificationHubState = this.store.select(selectUserNotificationHubState);

        // this.store.select(state => state.user.user).subscribe(user => {
        //     if (user) {
                this.notificationHubService.connect();
        //     }
        // });

        this.store.select(selectUserForbiddenInfo).subscribe(x => {
            if (x) {
                this.showForbiddenInfoWindow();
            } else {
                this.hideForbiddenInfoWindow();
            }
        });

    }

    public switchPreview() {
        if (this.currentPreviewStatus === PreviewStatus.Vertical) {
            this.layoutActionsService.setPreviewStatus(PreviewStatus.Horizontal);
        } else if (this.currentPreviewStatus === PreviewStatus.Horizontal) {
            this.layoutActionsService.setPreviewStatus(PreviewStatus.Vertical);
        }
    }

    public closePreview() {
        this.layoutActionsService.hidePreview();
    }

    public showPreview() {
        this.layoutActionsService.showPreview();
    }

    public changeMenuState() {
        const newState = this._menuState === MenuState.Dock ? MenuState.Float : MenuState.Dock;
        this.layoutActionsService.setMenuState(newState);
    }

    public ngOnInit(): void {

    }

    public clearObiektListState(listDefinitionType: ListDefinitionType): void {
        this.obiektListActionsService.resetStateByListType(listDefinitionType);
    }

    private forbiddenInfoWindow: WindowComponent<any>;

    private showForbiddenInfoWindow(): void {
        // this.forbiddenInfoWindow = this.windowService.add<WindowConfirmContentComponent>(WindowConfirmContentComponent);
        // this.forbiddenInfoWindow.component.text = 'Zostałeś wylogowany lub nie masz odpowiednich uprawnień. Kliknij OK, aby się zalogować ponownie.';
        // this.forbiddenInfoWindow.component.closed.subscribe((result: WindowResult) => {
        //     if (result === WindowResult.ok) {
        //         this.store.dispatch(userForbiddenInfoHide());
        //         this.authenticationService.redirectToLogInPage();
        //     } else if (result === WindowResult.cancel) {
        //         this.store.dispatch(userForbiddenInfoHide());
        //     }
        // });

        this.authenticationService.redirectToLogInPage();
    }

    private hideForbiddenInfoWindow(): void {
        if (this.forbiddenInfoWindow) {
            this.forbiddenInfoWindow.close();
        }
    }

    public onCerberMessageClick(): void {
        this.notificationService.clickHandler();
    }

    public onCerberMessageClose(): void {
        this.notificationService.closeCerberMessage();
    }

    public ngAfterContentChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    public openHealthCheck(): void {
        window.open(this.appSettings.settings.healthCheck.address);
    }

    public toggleNotificationHub(): void {
        this.notificationHubVisible = !this.notificationHubVisible;
    }
}